import React from "react";

type Props = {
  variant?: "fullheight" | "page";
};

const CenteredSpinner = ({ variant = "page" }: Props) => {
  return (
    <span
      className={`flex items-center justify-center ${
        variant === "fullheight" ? "h-[70vh]" : ""
      }`}
    >
      🌀 Loading...
    </span>
  );
};

export default CenteredSpinner;
